import { createContext } from 'react';
import type { RTCSession } from 'jssip/lib/RTCSession';

export const SipSessionContext = createContext<RTCSession | null>(null);
